import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ReportLayout from "examples/LayoutContainers/ReportLayout";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import URLs from "constants/urls";
import MonthlyOverView from "components/Forms/BusinessEntry/MonthEnd/monthlyOverView";
import MonthlyMISMain from "components/Accounts/MISReports/MonthlyMIS/monthlyMis";
import EmpProfitability from "components/Accounts/MISReports/EmployeeProfitability/empProfitability";
import MonthlyDSABusinessCard from "components/Accounts/MISReports/MonthlyBusiness/monthlyDsaBusiness";
import MonthlyBusinessByDsaCard from "components/Accounts/MISReports/MonthlyBusiness/monthlyBusinessDsa";
import ProductBusiness from "components/Accounts/MISReports/Reports/productBusiness";
import ProviderBusiness from "components/Accounts/MISReports/Reports/providerBusiness";
import InsuranceReportsheet from "components/Forms/BusinessEntry/Insurance/insuranceDashbrd";
import PipeLineReport from "components/Forms/BusinessEntry/PipeLine/pipeLine";
import ResponsiveButtonGroup from "./responnsiveTabs";
import ActualProfitAndLoss from "components/Accounts/MISReports/ActualP&L";
import DsaMaster from "components/Accounts/MISReports/DSAMasterReports/dsapost";
import PartialDisburementsReport from "components/Accounts/MISReports/Partialdisburements";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Height } from "@mui/icons-material";

const ReportsPanel = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeButton, setActiveButton] = useState(0);
  const tabs = [
    { label: "Month-End Business" },
    { label: "MIS Report" },
    { label: "Staff Profitability" },
    { label: "KH Business" },
    { label: "All DSA's Business" },
    { label: "Product Business" },
    { label: "KH Product Business" },
    { label: "Provider Business" },
    { label: "KH Provider Business" },
    { label: "Insurance Report" },
    { label: "Pipeline Business" },
    { label: "Actual P & L" },
    { label: "PartialDisburementsReport" },
  ];
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleButtonChange = (index) => {
    setActiveButton(index);
  };
  return (
    <ReportLayout>
      <span style={{ display: "block", paddingTop: "0.7em" }}></span>
      <ResponsiveButtonGroup
        buttons={tabs}
        activeButton={activeButton}
        onChange={handleButtonChange}
        bgColor="#E59400"
        width="100%"
      />
      {activeButton === 0 && <MonthlyOverView url={URLs.monthEndUrl} />}
      {activeButton === 1 && <MonthlyMISMain />}
      {activeButton === 2 && <EmpProfitability />}
      {activeButton === 3 && <MonthlyBusinessByDsaCard />}
      {activeButton === 4 && <MonthlyDSABusinessCard />}

      {activeButton === 5 && (
        <ProductBusiness
          productWiseBusinesByDateRange={URLs.alldsaproductwisereport}
          productWiseBusinessByProductId={URLs.khproductwisebifurcated}
          isItByDsa={false}
        />
      )}
      {activeButton === 6 && (
        <ProductBusiness
          productWiseBusinesByDateRange={URLs.khproductwisereport}
          productWiseBusinessByProductId={URLs.khproductwisebifurcated}
          isItByDsa={true}
        />
      )}
      {activeButton === 7 && (
        <ProviderBusiness
          // providerWiseBusinesByDateRange={URLs.providerWiseBusinesByDateRange}
          providerWiseBusinesByDateRange={URLs.alldsaproviderbusiness}
          providerWiseBusinessEntriesURL={URLs.providerWiseBusinessEntriesURL}
        />
      )}
      {activeButton === 8 && (
        <ProviderBusiness
          // providerWiseBusinesByDateRange={URLs.provderWiseBusinessByDsaId}
          providerWiseBusinesByDateRange={URLs.khproviderwisebusiness}
          // providerWiseBusinessEntriesURL={URLs.providerWiseEntriesByDsaId}
          providerWiseBusinessEntriesURL={URLs.khproviderbusinessbifurcatedreport}
          isItByDsa={true}
        />
      )}
      {activeButton === 9 && <InsuranceReportsheet />}
      {activeButton === 10 && <PipeLineReport />}
      {activeButton === 11 && <ActualProfitAndLoss />}
      {activeButton === 12 && <PartialDisburementsReport />}
    </ReportLayout>
  );
};
export default ReportsPanel;
